console.log('[cw] add-pdt asset running', document.currentScript && document.currentScript.src);

if (!window.__cwGridBound) {
  window.__cwGridBound = true;

  function formatMoney(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n / 100);
  }

  function getSelectedPriceFromOption(select) {
    const opt = select.options[select.selectedIndex];
    if (!opt) return null;

    let raw = (opt.dataset && (opt.dataset.price || opt.dataset.variantPrice)) || '';
    if (!raw) {
      const m = (opt.textContent || '').match(/([\d\s.,]+)\s*(?:€|EUR)/i);
      if (m) {
        const euros = m[1].replace(/\s/g, '').replace(',', '.');
        const cents = Math.round(parseFloat(euros) * 100);
        return Number.isFinite(cents) ? cents : null;
      }
      return null;
    }
    const p = parseInt(raw, 10);
    return Number.isFinite(p) ? p : null;
  }

  function updateBtnPriceForSelect(select) {
    const pid = select.getAttribute('data-product-id') || (select.dataset && select.dataset.productId);
    if (!pid) return false;

    const span = document.querySelector(`.btn-add-to-cart .btn-price[data-product-id="${pid}"]`);
    if (!span) return false;

    const price = getSelectedPriceFromOption(select);
    if (price == null) return false;

    span.textContent = formatMoney(price);
    return true;
  }

  function updateCardPriceFromSelect(select) {
    let ok = updateBtnPriceForSelect(select);
    setTimeout(() => updateBtnPriceForSelect(select) || ok, 50);
    setTimeout(() => updateBtnPriceForSelect(select) || ok, 300);
    return ok;
  }

  function onVariantEvent(e) {
    const select = e.target.closest && e.target.closest('.variant-dropdown[name="id"], .variant-dropdown');
    if (!select) return;
    updateCardPriceFromSelect(select);
  }

  // Écoute en capture pour passer avant certains scripts d’apps
  document.addEventListener('change', onVariantEvent, true);
  document.addEventListener('input',  onVariantEvent, true);

  function initAll() {
    document.querySelectorAll('.variant-dropdown').forEach(updateCardPriceFromSelect);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Events potentiels du thème
  document.addEventListener('variant:changed', (e) => {
    const select = e.target && e.target.closest && e.target.closest('.variant-dropdown') || document.querySelector('.variant-dropdown');
    if (select) updateCardPriceFromSelect(select);
  }, true);

  document.addEventListener('product:change', (e) => {
    const select = e.target && e.target.closest && e.target.closest('.variant-dropdown') || document.querySelector('.variant-dropdown');
    if (select) updateCardPriceFromSelect(select);
  }, true);
}


// --- Ouvrir le drawer panier (2 façons possibles) ---
function openCartDrawer() {
  // 1) Si ton thème a un bouton qui ouvre le drawer :
  const trigger = document.querySelector('.bt-sidebar-btn,[data-target="#bt-sidebar-cart"]');
  if (trigger) {
    // on déclenche un vrai clic (bubbling) pour laisser le thème gérer l’anim
    trigger.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true}));
    return;
  }
  // 2) Fallback: on force l’ouverture par classes body (selon ce que tu utilises déjà)
  document.body.classList.add('show-overlay','open-sidebar-canvas','open-sidebar-canvas--bt-sidebar-cart');
}

// --- Intercepter TOUTES les soumissions vers /cart/add(.js) ---
// capture=true pour passer AVANT les scripts du thème
document.addEventListener('submit', function(e){
  const form = e.target.closest('form');
  if (!form) return;

  const action = (form.getAttribute('action') || '').replace(location.origin,'');
  if (!/\/cart\/add(\.js)?$/.test(action)) return;

  // Empêcher la redirection vers /cart
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  // Anti double-clic
  const btn = form.querySelector('.btn-add-to-cart, [type="submit"]');
  if (btn) {
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    btn.disabled = true;
  }

  const originalHTML = btn ? btn.innerHTML : '';
  if (btn) btn.innerHTML = '🌀';

  const body = new URLSearchParams(new FormData(form)).toString();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body
  })
  .then(res => {
    if (!res.ok) throw new Error('add-to-cart failed');
    return res.json();
  })
  .then(() => {
    if (btn) btn.innerHTML = '✅';
    openCartDrawer(); // <- OUVRE LE SLIDER
    // reset doux
    setTimeout(() => {
      if (btn) {
        btn.disabled = false;
        btn.dataset.loading = '0';
        btn.innerHTML = originalHTML;
      }
    }, 1200);
  })
  .catch(() => {
    if (btn) btn.innerHTML = 'Error';
    setTimeout(() => {
      if (btn) {
        btn.disabled = false;
        btn.dataset.loading = '0';
        btn.innerHTML = originalHTML;
      }
    }, 1500);
  });

}, true);

// --- Bonus : si le thème/app utilise Shopify.onItemAdded, on hooke aussi ---
window.Shopify = window.Shopify || {};
const prevOnItemAdded = window.Shopify.onItemAdded;
window.Shopify.onItemAdded = function() {
  try { openCartDrawer(); } catch(e){}
  if (typeof prevOnItemAdded === 'function') prevOnItemAdded.apply(this, arguments);
};

